import React from 'react';
import { Icon } from '@pwc/pwc-deals-ui';
import { Modal } from 'react-bootstrap';
import './ModalLockingError.scss';
import { getBodyMessage, getTitleMessage } from './messages';

const ModalLockingError = ({
  show,
  onModalClose,
  actionName,
  contentType,
  userName,
}) => {
  if (!show) {
    return null;
  }

  const handleModalClose = () => {
    onModalClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleModalClose}
      className="modal-locking-error"
      centered
    >
      <Modal.Header>
        <Modal.Title>
          <>
            <span className="title-with-icon">
              <Icon name="alert" className="fill icon-yellow" width="24" />
              <span>{getTitleMessage(actionName, contentType)}</span>
            </span>
            <button
              className="ui-button button-no-appearance close-button"
              aria-label="Close topic modal"
              onClick={handleModalClose}
              type="button"
            >
              <Icon
                name="close"
                className="fill icon-orange-theme"
                width="18"
                height="18"
              />
            </button>
          </>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {getBodyMessage(actionName, contentType, userName)}
      </Modal.Body>
    </Modal>
  );
};

export default ModalLockingError;
